import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/free-solid-svg-icons";
import * as notify from "../../shared/notify";
import eventEmitter from "../../shared/events";

import Loader from "../loader/loader";

import { streamImageAttachment, deleteAttachment } from "./lib/resourceData";
import { EVENT_REFRESH_ATTACHMENTS } from "./lib/constants";

const ResourceDetail = (props) => {
    const [state, setState] = useState({
        img: "",
        pdf: "",
        error: "",
        isLoading: true,
    });

    useEffect(() => {
        if (props.number) {
            streamImage();
        }
    }, []);

    const streamImage = () => {
        streamImageAttachment(props.shipmentKey, props.number).then((fileData) => {
            const fileExt = props.filename.split(".").pop().toLowerCase();
            const newState = {};

            if (["jpg", "jpeg", "png", "gif"].includes(fileExt)) {
                newState.img = fileData;
                newState.pdf = "";
                newState.error = "";
            } else if (["pdf", "txt"].includes(fileExt)) {
                newState.img = "";
                newState.pdf = fileData;
                newState.error = "";
            } else {
                newState.img = "";
                newState.pdf = "";
                newState.error = fileData;
            }

            setState({
                ...newState,
                isLoading: false,
            });
        });
    };

    const deleteResource = async (e) => {
        const confirmed = await notify.confirm("Are you sure you want to delete this?");

        if (!confirmed) {
            return;
        }

        const response = await deleteAttachment(props.shipmentKey, props.number);

        if (!response) {
            return;
        }

        notify.success("Deleted");
        eventEmitter.emit(EVENT_REFRESH_ATTACHMENTS);
    };

    const preview = state.isLoading ? (
        <Loader natural={true} />
    ) : state.img ? (
        <img src={state.img} alt={props.name} />
    ) : state.pdf ? (
        <object data={state.pdf}>{props.name}</object>
    ) : (
        <div className="icon -large">
            <FontAwesomeIcon icon={faFile} />
        </div>
    );

    return (
        <div className="resource-detail row">
            <div className="column">
                <h3>{props.name}</h3>

                <p>Resource Note:</p>
                <p>{props.notes}</p>

                <div className="button-group -stacked">
                    <a className="button" href={state.img || state.pdf || state.error} download={props.filename}>
                        Download Resource
                    </a>
                    <button onClick={deleteResource} className="button -error">
                        Delete Resource
                    </button>
                </div>
            </div>
            <div className="column preview">{preview}</div>
        </div>
    );
};

export default ResourceDetail;
